import React, { useState } from 'react';
import { useLingui } from '@lingui/react';
import { CollapsedFaq } from '../../shared';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CollapseButton = _ref => {
  let {
    children
  } = _ref;
  const {
    i18n
  } = useLingui();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const ctaLabel = !isCollapsed ? i18n._('carlead.CollapseButtonFaq.button.label') : i18n._('carlead.CollapseButtonFaq.button.closed.label');
  return /*#__PURE__*/_jsxs("article", {
    className: `accordion-item ${isCollapsed ? 'opened' : ''}`,
    "data-category": "Accordion",
    children: [/*#__PURE__*/_jsx("button", {
      className: `accordion-title accordion-toggle btn btn-outline-secondary ${isCollapsed ? 'active' : ''}`,
      onClick: () => setIsCollapsed(previousState => !previousState),
      "data-tracking": true,
      "data-action": "Click",
      "data-label": isCollapsed ? 'Close FAQ' : 'Open FAQ',
      children: ctaLabel
    }), /*#__PURE__*/_jsx("div", {
      className: "accordion-content",
      children: children
    })]
  });
};
export const CarleadCollapseButtonFaq = () => {
  const {
    i18n
  } = useLingui();
  const title = i18n._('carlead.collapseButtonFaq.title');
  const text = i18n._('carlead.collapseButtonFaq.text');
  return /*#__PURE__*/_jsx("div", {
    className: "box gap white",
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("section", {
        className: "collapse-button__faq",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "section-title",
          children: title
        }), /*#__PURE__*/_jsx("p", {
          children: text
        }), /*#__PURE__*/_jsx(CollapseButton, {
          children: /*#__PURE__*/_jsx(CollapsedFaq, {
            headline: false,
            cta: false,
            type: "carlead"
          })
        })]
      })
    })
  });
};
export default CarleadCollapseButtonFaq;